import { IOption } from "../types";

import { ICustomOption } from "./types";

export const isCustomOption = (
  maybeCustomOption: IOption | ICustomOption
): maybeCustomOption is ICustomOption => {
  return "onValueChange" in maybeCustomOption;
};

export const getLabel = <T extends string = string>(option: IOption<T>) =>
  option.label;
export const getValue = <T extends string = string>(option: IOption<T>): T =>
  option.value;

export const getModularIndex = (index: number, maxValue: number) =>
  ((index % maxValue) + maxValue) % maxValue;
